const DEFAULT_DEV_API_BASE_URL = "http://localhost:3000";
export const APP_REQUEST_HEADER_NAME = "X-MTGMarket-Request";
export const APP_REQUEST_HEADER_VALUE = "1";

function trimTrailingSlash(value) {
  return String(value || "").replace(/\/+$/, "");
}

export function getApiBaseUrl() {
  const configuredBaseUrl = trimTrailingSlash(process.env.REACT_APP_API_BASE_URL || "");

  if (configuredBaseUrl) {
    return configuredBaseUrl;
  }

  if (typeof window === "undefined") {
    return DEFAULT_DEV_API_BASE_URL;
  }

  const { hostname, origin } = window.location;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return DEFAULT_DEV_API_BASE_URL;
  }

  return origin;
}

export function buildApiUrl(path) {
  const normalizedPath = String(path || "").startsWith("/") ? path : `/${path}`;
  return `${getApiBaseUrl()}${normalizedPath}`;
}

function isUnsafeMethod(method) {
  return ["POST", "PUT", "PATCH", "DELETE"].includes(String(method || "GET").trim().toUpperCase());
}

export function buildApiRequestHeaders(method = "GET", headers = {}) {
  return {
    ...(headers || {}),
    ...(isUnsafeMethod(method) ? { [APP_REQUEST_HEADER_NAME]: APP_REQUEST_HEADER_VALUE } : {})
  };
}

export function apiFetch(path, options = {}) {
  const { userId: _userId, headers, ...rest } = options;
  const method = rest.method || "GET";

  return fetch(buildApiUrl(path), {
    ...rest,
    credentials: "include",
    headers: buildApiRequestHeaders(method, headers)
  });
}